import React from 'react';
import { cn } from '@/lib/utils';

interface CitationBadgeProps {
  number: number;
  messageId?: string;
  occurrenceIndex?: number;
  isLast?: boolean;
  isHighlighted?: boolean;
  onClick?: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

export const CitationBadge: React.FC<CitationBadgeProps> = ({
  number,
  messageId,
  occurrenceIndex,
  isLast,
  isHighlighted,
  onClick,
  onMouseEnter,
  onMouseLeave,
}) => {
  const id = messageId && occurrenceIndex !== undefined
    ? `cite-${messageId}-${number}-${occurrenceIndex}`
    : undefined;

  if (!isLast) {
    return (
      <sup
        id={id}
        role="button"
        aria-label={`Citation ${number}`}
        className={cn(
          'inline-flex items-center justify-center w-4 h-4 mx-px rounded-full text-white text-[0.6rem] font-medium cursor-pointer transition-colors align-super',
          isHighlighted
            ? 'bg-neutral-600 dark:bg-neutral-400'
            : 'bg-neutral-400 dark:bg-neutral-600'
        )}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        {number}
      </sup>
    );
  }

  return (
    <span
      id={id}
      role="button"
      aria-label={`Citation ${number}`}
      className={cn(
        'inline-flex items-center px-2 py-0.5 mx-0.5 rounded-full text-white text-xs font-medium cursor-pointer transition-colors',
        isHighlighted
          ? 'bg-neutral-600 dark:bg-neutral-400'
          : 'bg-neutral-400 dark:bg-neutral-600'
      )}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {number}
    </span>
  );
};
